export default __webpack_public_path__ + "static/media/logo-light.c874dbc0.svg";